var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cart-button medium",class:{ 
    'proceed-button bold': _vm.isProceed,
    'disabled': _vm.isDisabled
  },attrs:{"disabled":_vm.isDisabled,"type":_vm.type}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }